var map = {
	"./bnb.svg": 3897,
	"./btcb.svg": 5969,
	"./busd.svg": 654,
	"./mfi.png": 2211,
	"./usdc.svg": 5040,
	"./usdt.svg": 683,
	"./wbnb.svg": 9163,
	"./weth.svg": 1803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8102;